import GenericDialog from "../../components/dialog/generic-dialog.component";
import {Alert, Box, Typography} from "@mui/material";
import * as React from "react";
import {translate} from "../../translate/translate";
import {
    DocumentElementWithFullscreen,
    DocumentWithFullscreen,
    toggleFullscreen
} from "../../models/components/fullscreen";
import {useEffect, useRef} from "react";
// import img from "../../../assets/images/img-modelo.png";
import {ReplenishmentService} from "../../services/replenishment-service";
import {ReplenishmentSpareParts} from "../../models/basic/replenishment";
import {formatDate} from "../../utils/format-date";
import {formatNumber} from "../../utils/format-number";

type ReplenishmentStockComponentProps = {
    openDialog: boolean;
    handleCloseDialog: () => void;
    selectedRow: ReplenishmentSpareParts;
}

const ReplenishmentStockComponent: React.FC<ReplenishmentStockComponentProps> = ({
        openDialog,
        handleCloseDialog,
        selectedRow,
}) => {
    const service = new ReplenishmentService();
    const imgRef = useRef<HTMLImageElement>(null);

    const [loadingDownload, setLoadingDownload] = React.useState<boolean>(false);
    const [imageUrl, setImageUrl] = React.useState<string>("");

    useEffect(() => {
        openDialog && downloadImage();
    }, [openDialog]);

    const alternarTelaCheia = () => {
        if (imgRef.current) {
            toggleFullscreen(
                document as DocumentWithFullscreen,
                imgRef.current as DocumentElementWithFullscreen
            );
        }
    }

    const downloadImage = async () => {
        if (selectedRow && selectedRow.material_number) {
            setLoadingDownload(true);
            service.forecast_download(selectedRow?.material_number).then(response => {
                setImageUrl(URL.createObjectURL(response.data));
            }).finally(() => {
                setLoadingDownload(false);
            });
        }
    }

    return (
        <GenericDialog
            open={openDialog}
            onClose={handleCloseDialog}
            title={"Estoque"}
            colorButton={"primary"}
            hideConfirmButton={true}
            closeButtonText={translate.t("close")}
            maxWidth="md"
            loading={loadingDownload}>
            <Box>
                <Box sx={{display: "flex", flexDirection: "row", gap: 2, marginBottom: 2}}>
                    <Typography variant="body1" width="40%"><strong>Código:</strong> {selectedRow?.material_number}</Typography>
                    <Typography variant="body1" width="50%"><strong>Descrição:</strong> {selectedRow?.description_portuguese}</Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", gap: 2, marginBottom: 2}}>
                    <Typography variant="body1"><strong>Previsão de falta de material:</strong> {selectedRow?.forecast_material_shortage} ({selectedRow?.forecast_material_shortage > 1 ?  'dias' : 'dia'})</Typography>
                    <Typography variant="body1">
                        <span
                            className="text"
                            style={{
                                width: '10px',
                                height: '10px',
                                backgroundColor: 'red',
                                borderRadius: '50%',
                                display: 'inline-block',
                                marginRight: '5px'
                            }}
                        />
                        <strong>Próxima data de compra: </strong>
                        {selectedRow?.next_purchase_date ? formatDate(selectedRow.next_purchase_date?.toString()) : "-"}
                    </Typography>
                    <Typography variant="body1"><strong>Qtde. para reposição:</strong> {selectedRow?.quantity_material_replacement} </Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row", gap: 2, marginBottom: 2}}>
                    <Typography variant="body1">
                        <strong>Estoque de segurança: </strong>
                        {selectedRow?.safety_stock ? selectedRow?.safety_stock : "-"}
                    </Typography>
                </Box>

                {!selectedRow?.next_purchase_date && (
                    <Alert severity="info" icon={false} sx={{ marginTop: "16px" }}>
                        <span>No momento, não há previsão de nova compra, pois não há demanda atual para o material</span>
                    </Alert>
                )}

                <div>
                    <img
                        ref={imgRef}
                        src={imageUrl}
                        alt="Imagem"
                        style={{ maxWidth: "100%", cursor: "zoom-in" }}
                        onClick={alternarTelaCheia}
                    />
                </div>
            </Box>
        </GenericDialog>
    );
}

export default ReplenishmentStockComponent;
